import { Button } from "@/components/ui/button";
import { Leaf, Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
            <Leaf className="w-5 h-5 text-primary-foreground" />
          </div>
          <span className="text-xl font-bold text-primary">سعدتك</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {isHome ? (
            <>
              <a href="#how-it-works" className="text-muted-foreground hover:text-primary transition-colors">
                كيف يعمل؟
              </a>
              <a href="#certifications" className="text-muted-foreground hover:text-primary transition-colors">
                الشهادات
              </a>
              <a href="#faq" className="text-muted-foreground hover:text-primary transition-colors">
                الأسئلة الشائعة
              </a>
              <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
                المدونة
              </Link>
              <Link to="/partenaire" className="text-muted-foreground hover:text-primary transition-colors">
                كن شريكًا معنا
              </Link>
            </>
          ) : (
            <>
              <Link to="/" className="text-muted-foreground hover:text-primary transition-colors">
                الرئيسية
              </Link>
              <Link to="/#how-it-works" className="text-muted-foreground hover:text-primary transition-colors">
                كيف يعمل؟
              </Link>
              <Link to="/#faq" className="text-muted-foreground hover:text-primary transition-colors">
                الأسئلة الشائعة
              </Link>
              <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
                المدونة
              </Link>
              <Link to="/partenaire" className="text-muted-foreground hover:text-primary transition-colors">
                كن شريكًا معنا
              </Link>
            </>
          )}
        </nav>

        {/* CTA Button */}
        <div className="flex items-center gap-4">
          <Link to="/questionnaire">
            <Button variant="gold" size="default" className="hidden md:flex">
              ابدأ الاستبيان
            </Button>
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-background border-b border-border">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-4">
            <Link 
              to="/" 
              className="text-muted-foreground hover:text-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              الرئيسية
            </Link>
            <a 
              href="#how-it-works" 
              className="text-muted-foreground hover:text-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              كيف يعمل؟
            </a>
            <a 
              href="#certifications" 
              className="text-muted-foreground hover:text-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              الشهادات
            </a>
            <a 
              href="#faq" 
              className="text-muted-foreground hover:text-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              الأسئلة الشائعة
            </a>
            <Link 
              to="/blog" 
              className="text-muted-foreground hover:text-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              المدونة
            </Link>
            <Link 
              to="/partenaire" 
              className="text-muted-foreground hover:text-primary transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              كن شريكًا معنا
            </Link>
            <Link 
              to="/questionnaire"
              onClick={() => setIsMenuOpen(false)}
            >
              <Button variant="gold" size="default" className="w-full">
                ابدأ الاستبيان
              </Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
